import { __decorate } from "tslib";
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
let PermissionsMixin = class PermissionsMixin extends Vue {
    accountData;
    get canEdit() {
        if (!this.$route.meta || !this.$route.meta.rightBlock) {
            return true;
        }
        return !!(this.currentUserRole && this.currentUserRole[this.$route.meta.rightBlock] && this.currentUserRole[this.$route.meta.rightBlock].update);
    }
    get canDelete() {
        if (!this.$route.meta || !this.$route.meta.rightBlock) {
            return true;
        }
        return !!(this.currentUserRole && this.currentUserRole[this.$route.meta.rightBlock] && this.currentUserRole[this.$route.meta.rightBlock].destroy);
    }
    get canRead() {
        if (!this.$route.meta || !this.$route.meta.rightBlock) {
            return true;
        }
        return !!(this.currentUserRole && this.currentUserRole[this.$route.meta.rightBlock] && this.currentUserRole[this.$route.meta.rightBlock].read);
    }
    get canCreate() {
        if (!this.$route.meta || !this.$route.meta.rightBlock) {
            return true;
        }
        return !!(this.currentUserRole && this.currentUserRole[this.$route.meta.rightBlock] && this.currentUserRole[this.$route.meta.rightBlock].create);
    }
    get canShowList() {
        if (!this.$route.meta || !this.$route.meta.rightBlock) {
            return true;
        }
        return !!(this.currentUserRole && this.currentUserRole[this.$route.meta.rightBlock] && this.currentUserRole[this.$route.meta.rightBlock].list);
    }
    get accessLockMonthPage() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.licence === 'advanced' || this.accountData.account.licence === 'essential';
    }
    get accessLockStatisticPage() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.licence === 'essential';
    }
    get emailCount() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.current_month_email_count;
    }
    get smsCount() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.current_month_sms_count;
    }
    get clientApiSupport() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.client_api_support;
    }
    get confirmRemoteSlotsSupport() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.confirm_remote_slots_support;
    }
    get geoScopeNational() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.geo_scope === 'national';
    }
    get geoScopeInternational() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.geo_scope === 'international';
    }
    get isUrlBuilderAvailable() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.url_builder_support;
    }
    get geoScopeCountries() {
        if (!this.geoScopeInternational) {
            return false;
        }
        return this.accountData.countries;
    }
    get isGeoScopeInternationalWithCountries() {
        return this.geoScopeCountries && this.geoScopeCountries.length && this.geoScopeInternational;
    }
    get geoCountryIsoCode() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.country_iso_code;
    }
    get calculateRouteForBranchesBooking() {
        if (!this.accountData) {
            return false;
        }
        return this.accountData.account.calculate_route_for_branches_booking;
    }
    get isBranchesFlow() {
        return this.user().account_organization_type === `with_all` || this.user().account_organization_type === `with_branches`;
    }
    get isAdvisor() {
        return this.user().kind === 'advisor';
    }
    get accountSalesforceSupport() {
        return this.accountData?.account?.salesforce_support;
    }
    get accountHubspotSupport() {
        return this.accountData?.account?.hubspot_support;
    }
    get accountMicrosoftDynamicsSupport() {
        return this.accountData?.account?.microsoft_dynamics_support;
    }
    get accountServicePointSupport() {
        return this.accountData?.account?.service_point_support;
    }
    get accountPrequestionSupport() {
        return this.accountData?.account?.prequestion_support || true;
    }
};
__decorate([
    State(state => state.CommonStore.accountData)
], PermissionsMixin.prototype, "accountData", void 0);
PermissionsMixin = __decorate([
    Component
], PermissionsMixin);
export default PermissionsMixin;
;
